const isChrome = navigator.userAgent.indexOf("Chrome") !== -1;
export default isChrome;
